"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyUpButton = ReadyUpButton;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const networking_1 = require("~/networking");
const players_1 = require("~/store/game/players");
const models_1 = require("@creature-chess/models");
const colors_1 = require("./colors");
const ui_1 = require("@creature-chess/ui");
// If the server hasn't confirmed our ready-up within this window, re-show the
// button so the player can try again rather than being stuck staring at empty
// space.
const READY_CONFIRM_TIMEOUT_MS = 3000;
const useStyles = (0, react_jss_1.createUseStyles)({
    button: {
        "background": colors_1.COLOR_READY_BUTTON,
        "color": colors_1.COLOR_READY_BUTTON_TEXT,
        "box-sizing": "border-box",
        "border": "none",
        "cursor": "pointer",
        "fontSize": "14px",
        "fontWeight": "700",
        "padding": "8px 8px",
        "letterSpacing": "2px",
        "width": "100%",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "12px",
            padding: "4px",
            letterSpacing: "1px",
        },
    },
});
function ReadyUpButton() {
    const gameActions = (0, networking_1.useGameActions)();
    const styles = useStyles();
    const localPlayer = (0, players_1.useLocalPlayer)();
    const isDead = (localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.health) === 0;
    const notReady = (localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.ready) === false;
    const inPreparingPhase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase === models_1.GamePhase.PREPARING);
    // Optimistic hide: flips true on click and back to false either when the
    // server confirms (notReady -> false), the phase advances, or the timeout
    // expires without confirmation.
    const [pendingReady, setPendingReady] = React.useState(false);
    const timerRef = React.useRef(null);
    const clearPendingTimer = React.useCallback(() => {
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    // Drop the optimistic flag whenever the underlying conditions for showing
    // the button no longer hold - server confirmed ready, phase moved on, or
    // the player died. Without this the flag could leak across rounds.
    React.useEffect(() => {
        if (!inPreparingPhase || !notReady || isDead) {
            clearPendingTimer();
            setPendingReady(false);
        }
    }, [inPreparingPhase, notReady, isDead, clearPendingTimer]);
    React.useEffect(() => clearPendingTimer, [clearPendingTimer]);
    const canReadyUp = inPreparingPhase && notReady && !isDead && !pendingReady;
    const onReadyUp = React.useCallback(() => {
        if (!canReadyUp) {
            return;
        }
        setPendingReady(true);
        clearPendingTimer();
        timerRef.current = setTimeout(() => {
            timerRef.current = null;
            setPendingReady(false);
        }, READY_CONFIRM_TIMEOUT_MS);
        gameActions.readyUp();
    }, [canReadyUp, clearPendingTimer, gameActions]);
    if (!canReadyUp) {
        // To keep the Sell button in the same place
        return React.createElement("div", null);
    }
    return (React.createElement(ui_1.Button, { color: "secondary", size: "small", onClick: onReadyUp }, "Ready"));
}
